import React from "react";

function Privacy(props) {
  return (
    <div className="bg-gray-100 py-16 px-6 animate__animated animate__fadeIn mt-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 mt-6 sm:mt-10 md:mt-20">
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">
          Политика конфиденциальности AJAR MEBEL
        </h2>
        <h2 className="text-xl font-semibold text-gray-800 ">
          Ваша конфиденциальность <br />
          Мы ценим вашу конфиденциальность и защищаем личные данные.
        </h2>
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Какие данные собираем:
        </h2>
        <ul className="list-decimal pl-6">
          <li className="text-gray-700 mb-4">
            Имя, телефон, e-mail, адрес доставки, платежные данные.
          </li>
        </ul>
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Как используем:
        </h2>
        <ul className="list-decimal pl-6">
          <li className="text-gray-700">
            Для обработки заказов, уведомлений о статусе, поддержки клиентов.{" "}
          </li>
          <li>Для отправки акций и предложений (с вашего согласия).</li>
          <li className="text-gray-700">
            При вопросах о нашей политике свяжитесь с нами.
          </li>
        </ul>
        <h2 className="text-3xl font-semibold text-gray-800 mt-12">
          AJAR MEBEL купуялуулук саясаты
        </h2>
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Сиздин купуялуулугуңуз <br />
          Биз сиздин жеке маалыматыңызды коргоого өзгөчө көңүл бурабыз.
        </h2>

        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Чогултулган маалыматтар:
        </h2>
        <ul className="list-decimal pl-6">
          <li className="text-gray-700 mb-4">Аты-жөнү, телефону, e-mail.</li>
          <li className="text-gray-700 mb-4">Жеткирүү дареги.</li>
          <li className="text-gray-700 mb-4">Төлөм маалыматтары.</li>
        </ul>
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Колдонуу максаты:
        </h2>
        <ul className="list-decimal pl-6">
          <li className="text-gray-700">
            Заказдарды иштетүү жана статусун билдирүү.
          </li>
          <li className="text-gray-700 ">Кардарларды колдоо.</li>
          <li className="text-gray-700 ">
            Акциялар жана жаңылыктар тууралуу маалымат жөнөтүү (сиздин
            макулдугуңуз менен)
          </li>
        </ul>
          <p className="text-gray-800 mt-2 text-xl font-semibold">
            Суроолоруңуз болсо, биз менен байланышуудан тартынбаңыз.
          </p>
      </div>
    </div>
  );
}

export default Privacy;
